import { render, staticRenderFns } from "./layout-gg.vue?vue&type=template&id=278648cb"
import script from "./layout-gg.vue?vue&type=script&lang=js"
export * from "./layout-gg.vue?vue&type=script&lang=js"
import style0 from "./layout-gg.vue?vue&type=style&index=0&id=278648cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports